export default "__VITE_ASSET__bc45b736__"